import { render, staticRenderFns } from "./BidDetails.vue?vue&type=template&id=a2be5088&scoped=true"
import script from "./BidDetails.vue?vue&type=script&lang=js"
export * from "./BidDetails.vue?vue&type=script&lang=js"
import style0 from "./BidDetails.vue?vue&type=style&index=0&id=a2be5088&prod&scoped=true&lang=css"
import style1 from "./BidDetails.vue?vue&type=style&index=1&id=a2be5088&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2be5088",
  null
  
)

export default component.exports